/**
 * TODO 画面から「今日の過ごし方」の設定（睡眠の計画の設定シート）を開くボタン
 */

import { Loader2, Settings } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { useSleepStore } from '@/store/useSleepStore'

import { SleepSettingsSheet } from '../sleep/components/plan-sections'

export const TodaySettingsButton = () => {
  const plan = useSleepStore((s) => s.plan)
  const fetchPlan = useSleepStore((s) => s.fetchPlan)
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  // 設定は睡眠の計画と一緒に読むので、TODO 画面でまだ読んでいなければ読んでから開く
  const handleOpen = async () => {
    if (!plan) {
      setLoading(true)
      await fetchPlan(true)
      setLoading(false)
    }
    setOpen(true)
  }

  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        className="ml-auto h-6 gap-1 px-2! text-[11px] text-muted-foreground"
        disabled={loading}
        onClick={() => void handleOpen()}
      >
        {loading ? <Loader2 className="size-3 animate-spin" /> : <Settings className="size-3" />}
        過ごし方の設定
      </Button>
      {plan && <SleepSettingsSheet settings={plan.settings} open={open} onOpenChange={setOpen} />}
    </>
  )
}
